import type { TranslationArgs } from '@sjzy/ui'
import type { App } from 'vue'
import i18n from '@/i18n'
import request from '@/utils/http/request'
import SjzyUi, { clickOutside, formV2Adapter, permission } from '@sjzy/ui'
import '@sjzy/ui/es/style.css'
import 'viewerjs/dist/viewer.css'

export function setupSjzyUi(app: App) {
  SjzyUi.setup({
    systemKey: 'CRM',
    i18n: (key: string, args?: TranslationArgs) => (i18n as any).global.t(key, args),
    table: {
      mouseConfig: { selected: false, area: true, extension: true },
      keyboardConfig: { isClip: true, isEsc: false },
      isAreaCheckboxSelection: false,
    },
    icon: {
      refreshIcon: 'icon-a-shuaxin3',
      columnIcon: 'icon-a-shezhi4',
      customIcon: 'icon-gengduoneirong',
      searchIcon: 'icon-chakan',
      editIcon: 'icon-a-bianji1',
      delIcon: 'icon-a-shanchu9',
      delFilledIcon: 'icon-a-shanchu10',
      exportIcon: 'icon-baoguofahuo',
      importIcon: 'icon-a-shangchuan2',
      dragIcon: 'icon-tuozhuai',
      topIcon: 'icon-a-zhiding4',
      fixedIcon: 'icon-tuding',
      unFixedIcon: 'icon-a-tuding1',
      fixedRightIcon: 'icon-tuding',
      unFixedRightIcon: 'icon-a-tuding1',
      closeIcon: 'icon-qingkong',
      addIcon: 'icon-tianjia',
      addCircleFiledIcon: 'icon-xinzeng',
    } as any,
  })
  SjzyUi.setXHR(request as any)
  formV2Adapter({})
  app.use(SjzyUi)

  app.directive('clickOutside', clickOutside)
  app.directive('permission', permission)
}
